//bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
// bao migrate - module not found: import "services/bao-template-engine";
Bao.Templates.hierarchicalPermissionTree = "<ul data-bind=\"foreach: Nodes\"><li data-bind='visible: $parent.Expanded'><i class=\"fa\" data-bind=\"click: $root.ToggleNode, css: Icon, visible: Icon() != ''\"></i>        <span data-bind=\"css: {selected: $root.SelectedNode() == $data}\"><a data-bind=\"click: $root.NodeClick\"><span data-bind=\"text: Text\"></span><span class=\"badge synoset\" data-bind=\"visible: CountVisible, text: Count\"></span></a></span><!-- ko template: 'hierarchicalPermissionTree' --><!-- /ko -->    </li></ul>";
ko.bindingHandlers.hierarchicalPermissionTree = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        $(element).addClass("hierarchicalPermissionTree");
        var hierarchicalPermissionTreeVM = function () {
            var self = this;
            self.ToggleNode = function (node) {
                node.Expanded(!node.Expanded());
                if (valueAccessor().NodeToggled != undefined) {
                    valueAccessor().NodeToggled(node);
                }
            };
            self.NodeClick = function (node) {
                self.SelectedNode(node);
            };
            self.nodeClicked = function (node, e) {
                self.ClickedNode(node);
                return true;
            };
            self.Expanded = ko.observable(true);
            // return self;
        };
        var newContext = ko.utils.extend(new hierarchicalPermissionTreeVM(), valueAccessor());
        $(element).html(Bao.Templates.hierarchicalPermissionTree);
        ko.applyBindingsToDescendants(newContext, element);
        return {
            controlsDescendantBindings: true
        };
    }
};